/* --------------- Main Manu --------------- */

.mainmenu {
    list-style-type: none;
}

.mainmenu a {
    display: block;
    padding: 5px 0;
    border-bottom: 1px dotted #2f7aff;
    text-decoration: none;
}

.mainmenu a:hover {
    background-color: #edf3fc;
    text-decoration: none;
    color: #ff6600;
}

.menuTop {
    padding-left: 0.5em;
}

.menuMain {
    padding-left: 0.5em;
}

.menuSub {
    padding-left: 1em;
}
